import PostsAdapter from './base';

export default class Text extends PostsAdapter {
  modelNamePlural = 'texts';
}
